module.exports = __webpack_public_path__ + "020f8914cd9d5b24a9a2480228a6667b.png";